// Shared, verifierad projektdatabas. Single source of truth för
// referensprojekt över hela sajten (startsida, /referenser, stadssidor).
//
// Lägg till nya projekt genom att append:a ett objekt till PROJECTS-arrayen.
// Inga sidor behöver kodas om — /referenser-filtret, HeroTrustBar,
// ProjectFeed och CityPage läser direkt härifrån.

import kistaScience1 from "@/assets/projekt/kista-science-tower-1.jpg.asset.json";
import kistaEntre1 from "@/assets/projekt/kista-entre-1.jpg.asset.json";
import privatUterum1 from "@/assets/projekt/privat-uterum.jpg.asset.json";
import loddekopinge1 from "@/assets/projekt/loddekopinge-1.jpg.asset.json";
import loddekopinge2 from "@/assets/projekt/loddekopinge-2.jpg.asset.json";
import loddekopinge3 from "@/assets/projekt/loddekopinge-3.jpg.asset.json";
import loddekopinge4 from "@/assets/projekt/loddekopinge-4.jpg.asset.json";
import loddekopinge5 from "@/assets/projekt/loddekopinge-5.jpg.asset.json";
import loddekopinge6 from "@/assets/projekt/loddekopinge-6.jpg.asset.json";
import vasakronanKista1 from "@/assets/projekt/vasakronan-kista-1.jpg.asset.json";
import vasakronanKista2 from "@/assets/projekt/vasakronan-kista-2.jpg.asset.json";
import vasakronanKista3 from "@/assets/projekt/vasakronan-kista-3.jpg.asset.json";
import vasakronanKista4 from "@/assets/projekt/vasakronan-kista-4.jpg.asset.json";
import vasakronanKista5 from "@/assets/projekt/vasakronan-kista-5.jpg.asset.json";
import vasakronanKista6 from "@/assets/projekt/vasakronan-kista-6.jpg.asset.json";
import sjobo1 from "@/assets/projekt/sjobo-1.jpeg.asset.json";
import sjobo2 from "@/assets/projekt/sjobo-2.jpeg.asset.json";
import doubley1 from "@/assets/projekt/doubley-1.jpeg.asset.json";
import doubley2 from "@/assets/projekt/doubley-2.jpeg.asset.json";
import doubley3 from "@/assets/projekt/doubley-3.jpeg.asset.json";
import doubley4 from "@/assets/projekt/doubley-4.jpeg.asset.json";
import doubley5 from "@/assets/projekt/doubley-5.jpeg.asset.json";
import helsingborgPrestige70_1 from "@/assets/projekt/helsingborg-prestige70-1.jpeg.asset.json";
import vista99xcHelsingborg1 from "@/assets/projekt/vista-99xc-helsingborg-1.jpeg.asset.json";
import frostMalmo1 from "@/assets/projekt/frost-malmo-b2159f91.jpg.asset.json";
import frostMalmo2 from "@/assets/projekt/frost-malmo-c7b707e0.jpg.asset.json";
import frostMalmo3 from "@/assets/projekt/frost-malmo-0ca6b21c.jpg.asset.json";
import prestige40Arlov1 from "@/assets/projekt/prestige-40-arlov-1.jpeg.asset.json";
import prestige40Vellinge1 from "@/assets/projekt/prestige-40-vellinge-1.jpg.asset.json";
import prestige70Malmo1 from "@/assets/projekt/prestige-70-malmo-1.jpg.asset.json";
import prestige40xMalmo1 from "@/assets/projekt/prestige-40x-malmo-1.jpg.asset.json";
import prestige40xMalmo2 from "@/assets/projekt/prestige-40x-malmo-2.jpg.asset.json";
import prestige40xVellinge1 from "@/assets/projekt/prestige-40x-vellinge-1.jpg.asset.json";
import prestige40xVellinge2 from "@/assets/projekt/prestige-40x-vellinge-2.jpg.asset.json";
import prestige40xVellinge3 from "@/assets/projekt/prestige-40x-vellinge-3.jpg.asset.json";
import kalmarhem1 from "@/assets/projekt/kalmarhem-1.jpg.asset.json";
import kalmarhem2 from "@/assets/projekt/kalmarhem-2.jpg.asset.json";
import kalmarhem3 from "@/assets/projekt/kalmarhem-3.jpg.asset.json";
import kalmarhem4 from "@/assets/projekt/kalmarhem-4.jpg.asset.json";
import kalmarhem5 from "@/assets/projekt/kalmarhem-5.jpg.asset.json";
import ekebyskolan1 from "@/assets/projekt/ekebyskolan-1.jpg.asset.json";
import svenskakyrkan1 from "@/assets/projekt/svenskakyrkan-1.jpeg.asset.json";
import svenskakyrkan2 from "@/assets/projekt/svenskakyrkan-2.jpeg.asset.json";
import svenskakyrkan3 from "@/assets/projekt/svenskakyrkan-3.jpeg.asset.json";
import handelsbankenFasad from "@/assets/handelsbanken-fasad.jpg.asset.json";
import wihlborgs1 from "@/assets/projekt/wihlborgs-1.jpg.asset.json";
import wihlborgs2 from "@/assets/projekt/wihlborgs-2.jpg.asset.json";
import wihlborgs3 from "@/assets/projekt/wihlborgs-3.jpg.asset.json";
import wihlborgs4 from "@/assets/projekt/wihlborgs-4.jpg.asset.json";
import wihlborgs5 from "@/assets/projekt/wihlborgs-5.jpg.asset.json";
import raaHelsingborg1 from "@/assets/projekt/raa-helsingborg-1.jpg.asset.json";
import sixt1 from "@/assets/projekt/sixt-1.jpg.asset.json";
import sixt2 from "@/assets/projekt/sixt-2.jpg.asset.json";
import alfalaval1 from "@/assets/projekt/alfa-laval-1.jpg.asset.json";
import alfalaval2 from "@/assets/projekt/alfa-laval-2.jpg.asset.json";
import alfalaval3 from "@/assets/projekt/alfa-laval-3.jpg.asset.json";
import alfalaval4 from "@/assets/projekt/alfa-laval-4.jpg.asset.json";
import alfalaval5 from "@/assets/projekt/alfa-laval-5.jpg.asset.json";
import hassleholm1 from "@/assets/projekt/hassleholm-1.jpg.asset.json";
import hassleholm2 from "@/assets/projekt/hassleholm-2.jpg.asset.json";
import hassleholm3 from "@/assets/projekt/hassleholm-3.jpg.asset.json";
import hassleholm4 from "@/assets/projekt/hassleholm-4.jpg.asset.json";
import hassleholm5 from "@/assets/projekt/hassleholm-5.jpg.asset.json";
import hassleholm6 from "@/assets/projekt/hassleholm-6.jpg.asset.json";
import hassleholm7 from "@/assets/projekt/hassleholm-7.jpg.asset.json";
import vistahuset1 from "@/assets/projekt/vistahuset-1.jpg.asset.json";
import vistahuset2 from "@/assets/projekt/vistahuset-2.jpg.asset.json";
import vistahuset3 from "@/assets/projekt/vistahuset-3.jpg.asset.json";
import vistahuset4 from "@/assets/projekt/vistahuset-4.jpg.asset.json";
import vistahuset5 from "@/assets/projekt/vistahuset-5.jpg.asset.json";
import vistahuset6 from "@/assets/projekt/vistahuset-6.jpg.asset.json";
import vistahuset7 from "@/assets/projekt/vistahuset-7.jpg.asset.json";
import vistahuset8 from "@/assets/projekt/vistahuset-8.jpg.asset.json";
import monbijouskolan1 from "@/assets/projekt/monbijouskolan-1.jpg.asset.json";
import monbijouskolan2 from "@/assets/projekt/monbijouskolan-2.png.asset.json";
import atea1 from "@/assets/projekt/atea-malmo-1.jpg.asset.json";
import atea2 from "@/assets/projekt/atea-malmo-2.jpg.asset.json";
import atea3 from "@/assets/projekt/atea-malmo-3.jpg.asset.json";
import atea4 from "@/assets/projekt/atea-malmo-4.jpg.asset.json";
import atea5 from "@/assets/projekt/atea-malmo-5.jpg.asset.json";
import atea6 from "@/assets/projekt/atea-malmo-6.jpg.asset.json";
import atea7 from "@/assets/projekt/atea-malmo-7.jpg.asset.json";
import restaurangAster1 from "@/assets/projekt/restaurang-aster-malmo-1.jpg.asset.json";
import hoganasHamnservering1 from "@/assets/projekt/hoganas-hamnservering-1214.jpg.asset.json";
import hoganasHamnservering2 from "@/assets/projekt/hoganas-hamnservering-1211.jpg.asset.json";
import hoganasHamnservering3 from "@/assets/projekt/hoganas-hamnservering-1216.jpg.asset.json";
import hoganasHamnservering4 from "@/assets/projekt/hoganas-hamnservering-1210.jpg.asset.json";
import hoganasHamnservering5 from "@/assets/projekt/hoganas-hamnservering-1209.jpg.asset.json";
import hoganasHamnservering6 from "@/assets/projekt/hoganas-hamnservering-1208.jpg.asset.json";



export type ProductCategory = "Solfilm" | "Säkerhetsfilm" | "Dekorfilm";
export type CustomerType =
  | "Kontor"
  | "Butik"
  | "Skola"
  | "Vård"
  | "Offentlig"
  | "BRF"
  | "Villa"
  | "Industri";

export interface Project {
  slug: string;
  image: string;
  city: string;
  type: string;
  /** Uppdragsgivare / kund — highlightas i referenskort och lightbox. */
  client: string;
  /** Visningskategori (bibehållen för befintliga feeds, t.ex. ProjectFeed-badge). */
  category: string;
  /** Filterbar produktkategori. */
  productCategory: ProductCategory;
  /** Filterbar kundtyp. */
  customerType: CustomerType;
  product: string;
  area: string;
  /** Region — valfri; utelämnas när orten inte är publik (t.ex. kunder som inte vill visas geografiskt). */
  region?: "stockholm" | "skane" | "vastra-gotaland" | "smaland";
  /** Kort resultat-/effektbeskrivning, valfri. Visas i kort om satt. */
  result?: string;
  /** Extra bilder från samma projekt (visas i referensgalleriet). */
  gallery?: string[];
  /** Nålfäst projekt — ligger alltid överst oavsett ålder. */
  pinned?: boolean;
}

export const PROJECTS: Project[] = [
  // ─── Stockholm ────────────────────────────────────────────────
  {
    slug: "kista-science-tower",
    image: kistaScience1.url,
    city: "Stockholm",
    type: "Kista Science Tower",
    client: "Kista Science Tower",
    category: "Kontor",
    productCategory: "Solfilm",
    customerType: "Kontor",
    product: "3M Prestige 40x",
    area: "3 800 kvm",
    region: "stockholm",
    pinned: true,
  },
  {
    slug: "kista-entre",
    image: kistaEntre1.url,
    city: "Stockholm",
    type: "Kista Entré",
    client: "Kista Entré",
    category: "Kontor",
    productCategory: "Solfilm",
    customerType: "Kontor",
    product: "3M Prestige 70i",
    area: "1 050 kvm",
    region: "stockholm",
  },

  // ─── Skåne ────────────────────────────────────────────────────
  {
    slug: "borgeby-uterum",
    image: privatUterum1.url,
    city: "Borgeby",
    type: "Borgeby Uterum",
    client: "Privatkund, Borgeby",
    category: "Uterum / Privat",
    productCategory: "Solfilm",
    customerType: "Villa",
    product: "3M Prestige 70x + 40x",
    area: "45 kvm",
    region: "skane",
  },
  {
    slug: "vasakronan-kista",
    image: vasakronanKista1.url,
    city: "Kista",
    type: "Vasakronan Kista",
    client: "Vasakronan",
    category: "Kontor",
    productCategory: "Solfilm",
    customerType: "Kontor",
    product: "3M Prestige 70x",
    area: "130 kvm",
    region: "stockholm",
    gallery: [
      vasakronanKista1.url,
      vasakronanKista2.url,
      vasakronanKista3.url,
      vasakronanKista4.url,
      vasakronanKista5.url,
      vasakronanKista6.url,
    ],
  },
  {
    slug: "loddekopinge-prestige-40x",
    image: loddekopinge1.url,
    city: "Löddeköpinge",
    type: "Prestige 40x Löddeköpinge",
    client: "Löddeköpinge",
    category: "Kontor",
    productCategory: "Solfilm",
    customerType: "Kontor",
    product: "3M Prestige 40x",
    area: "50 kvm",
    region: "skane",
    gallery: [
      loddekopinge1.url,
      loddekopinge2.url,
      loddekopinge3.url,
      loddekopinge4.url,
      loddekopinge5.url,
      loddekopinge6.url,
    ],
  },
  {
    slug: "sjobo-prestige-40x",
    image: sjobo1.url,
    city: "Sjöbo",
    type: "Prestige 40x Sjöbo",
    client: "Sjöbo",
    category: "Kontor",
    productCategory: "Solfilm",
    customerType: "Kontor",
    product: "3M Prestige 40x",
    area: "50 kvm",
    region: "skane",
    gallery: [sjobo1.url, sjobo2.url],
  },
  {
    slug: "helsingborg-prestige-70",
    image: helsingborgPrestige70_1.url,
    city: "Helsingborg",
    type: "Prestige 70 Helsingborg",
    client: "Privatkund, Helsingborg",
    category: "Villa",
    productCategory: "Solfilm",
    customerType: "Villa",
    product: "3M Prestige 70 Exterior",
    area: "Villafönster",
    region: "skane",
    gallery: [helsingborgPrestige70_1.url],
  },
  {
    slug: "vista-99xc-helsingborg",
    image: vista99xcHelsingborg1.url,
    city: "Helsingborg",
    type: "Vista 99xc Helsingborg",
    client: "Privatkund, Helsingborg",
    category: "Villa",
    productCategory: "Solfilm",
    customerType: "Villa",
    product: "3M Vista 99xc",
    area: "Villafönster",
    region: "skane",
    gallery: [vista99xcHelsingborg1.url],
  },
  {
    slug: "prestige-40-arlov",
    image: prestige40Arlov1.url,
    city: "Arlöv",
    type: "Prestige 40 Arlöv",
    client: "Privatkund, Arlöv",
    category: "Villa",
    productCategory: "Solfilm",
    customerType: "Villa",
    product: "3M Prestige 40 Exterior",
    area: "Villafönster",
    region: "skane",
    gallery: [prestige40Arlov1.url],
  },
  {
    slug: "prestige-40-vellinge",
    image: prestige40Vellinge1.url,
    city: "Vellinge",
    type: "Prestige 40 Vellinge",
    client: "Privatkund, Vellinge",
    category: "Villa",
    productCategory: "Solfilm",
    customerType: "Villa",
    product: "3M Prestige 40 Exterior",
    area: "Uterum / villafönster",
    region: "skane",
    gallery: [prestige40Vellinge1.url],
  },
  {
    slug: "prestige-70-malmo",
    image: prestige70Malmo1.url,
    city: "Malmö",
    type: "Prestige 70 Malmö",
    client: "Privatkund, Malmö",
    category: "Villa",
    productCategory: "Solfilm",
    customerType: "Villa",
    product: "3M Prestige 70 Exterior",
    area: "Balkong- och terrassfönster",
    region: "skane",
    gallery: [prestige70Malmo1.url],
  },
  {
    slug: "prestige-40x-malmo",
    image: prestige40xMalmo1.url,
    city: "Malmö",
    type: "Prestige 40x Malmö",
    client: "Privatkund, Malmö",
    category: "Villa",
    productCategory: "Solfilm",
    customerType: "Villa",
    product: "3M Prestige 40x",
    area: "Villafönster",
    region: "skane",
    gallery: [prestige40xMalmo1.url, prestige40xMalmo2.url],
  },
  {
    slug: "prestige-40x-vellinge",
    image: prestige40xVellinge1.url,
    city: "Vellinge",
    type: "Prestige 40x Vellinge",
    client: "Privatkund, Vellinge",
    category: "Villa",
    productCategory: "Solfilm",
    customerType: "Villa",
    product: "3M Prestige 40x",
    area: "Villafönster",
    region: "skane",
    gallery: [prestige40xVellinge1.url, prestige40xVellinge2.url, prestige40xVellinge3.url],
  },
  {
    slug: "doubley-malmo-lund",
    image: doubley5.url,
    city: "Malmö & Lund",
    type: "Logo & SALE-dekor – Double-Y",
    client: "Double-Y",
    category: "Butik",
    productCategory: "Dekorfilm",
    customerType: "Butik",
    product: "Skuren butiksdekor (logo + kampanj)",
    area: "5 skyltfönster",
    region: "skane",
    gallery: [doubley1.url, doubley2.url, doubley3.url, doubley4.url, doubley5.url],
  },
  {
    slug: "frost-malmo",
    image: frostMalmo1.url,
    city: "Malmö",
    type: "Frostfilm kontor",
    client: "Frost Malmö",
    category: "Kontor",
    productCategory: "Dekorfilm",
    customerType: "Kontor",
    product: "Frostad dekorfilm (insynsskydd)",
    area: "Kontorslokal",
    region: "skane",
    result: "Insynsskydd på fönster mot gata — bevarar dagsljus utan gardiner.",
    gallery: [frostMalmo1.url, frostMalmo2.url, frostMalmo3.url],
  },
  {
    slug: "kalmarhem-prestige-70x",
    image: kalmarhem1.url,
    city: "Kalmar",
    type: "Kalmarhem",
    client: "Kalmarhem",
    category: "Bostadsbolag",
    productCategory: "Solfilm",
    customerType: "BRF",
    product: "3M Prestige 70x",
    area: "1 150 kvm",
    region: "smaland",
    gallery: [
      kalmarhem1.url,
      kalmarhem2.url,
      kalmarhem3.url,
      kalmarhem4.url,
      kalmarhem5.url,
    ],
  },
  {
    slug: "ekebyskolan-chrome-285xc",
    image: ekebyskolan1.url,
    city: "Bjuv",
    type: "Ekebyskolan",
    client: "Ekebyskolan",
    category: "Skola",
    productCategory: "Solfilm",
    customerType: "Skola",
    product: "Solar Screen Chrome 285xc",
    area: "40 kvm",
    region: "skane",
    gallery: [ekebyskolan1.url],
  },
  {
    slug: "svenska-kyrkan-kontrastmarkering",
    image: svenskakyrkan1.url,
    city: "",
    type: "Svenska kyrkan",
    client: "Svenska kyrkan",
    category: "Kontrastmarkering",
    productCategory: "Dekorfilm",
    customerType: "Offentlig",
    product: "Kontrastmarkering",
    area: "50 dörrar & glaspartier",
    gallery: [svenskakyrkan1.url, svenskakyrkan2.url, svenskakyrkan3.url],
  },
  {
    slug: "handelsbanken-prestige-40",
    image: handelsbankenFasad.url,
    city: "Stockholm",
    type: "Handelsbanken",
    client: "Handelsbanken",
    category: "Kontor",
    productCategory: "Solfilm",
    customerType: "Kontor",
    product: "3M Prestige 40",
    area: "400 kvm",
    region: "stockholm",
    result: "Solskyddsfolie monterad på alla glaspartier på 4 dagar — svalare inomhusklimat inför sommaren.",
    gallery: [handelsbankenFasad.url],
  },
  {
    slug: "wihlborgs-prestige-50x",
    image: wihlborgs1.url,
    city: "",
    type: "Wihlborgs Fastigheter",
    client: "Wihlborgs Fastigheter",
    category: "Kontor",
    productCategory: "Solfilm",
    customerType: "Kontor",
    product: "3M Prestige 50x",
    area: "130 kvm",
    result: "Solfilm monterad i trapphus — 130 kvm.",
    gallery: [
      wihlborgs1.url,
      wihlborgs2.url,
      wihlborgs3.url,
      wihlborgs4.url,
      wihlborgs5.url,
    ],
  },
  {
    slug: "prestige-70x-raa",
    image: raaHelsingborg1.url,
    city: "Helsingborg",
    type: "Prestige 70x Råå",
    client: "Privatkund, Råå",
    category: "Villa",
    productCategory: "Solfilm",
    customerType: "Villa",
    product: "3M Prestige 70x",
    area: "12 kvm",
    region: "skane",
    gallery: [raaHelsingborg1.url],
  },
  {
    slug: "sixt-prestige-50x",
    image: sixt1.url,
    city: "",
    type: "SIXT",
    client: "SIXT",
    category: "Kontor",
    productCategory: "Solfilm",
    customerType: "Kontor",
    product: "3M Prestige 50x",
    area: "85 kvm",
    result: "Solfilm monterad på 33 fönster — totalt 85 kvm.",
    gallery: [sixt1.url, sixt2.url],
  },
  {
    slug: "alfa-laval-prestige-40x",
    image: alfalaval1.url,
    city: "",
    type: "Alfa Laval",
    client: "Alfa Laval",
    category: "Industri",
    productCategory: "Solfilm",
    customerType: "Industri",
    product: "3M Prestige 40x",
    area: "450 kvm",
    result: "Solfilm monterad på 386 fönster — totalt 450 kvm.",
    gallery: [
      alfalaval1.url,
      alfalaval2.url,
      alfalaval3.url,
      alfalaval4.url,
      alfalaval5.url,
    ],
  },
  {
    slug: "prestige-70x-hassleholm",
    image: hassleholm1.url,
    city: "Hässleholm",
    type: "Prestige 70x Hässleholm",
    client: "Privatkund, Hässleholm",
    category: "Villa",
    productCategory: "Solfilm",
    customerType: "Villa",
    product: "3M Prestige 70x",
    area: "Ca 20 kvm",
    region: "skane",
    gallery: [
      hassleholm1.url,
      hassleholm2.url,
      hassleholm3.url,
      hassleholm4.url,
      hassleholm5.url,
      hassleholm6.url,
      hassleholm7.url,
    ],
  },
  {
    slug: "vistahuset-vista-90xc",
    image: vistahuset6.url,
    city: "Malmö",
    type: "Vistahuset",
    client: "Vistahuset",
    category: "Kontor",
    productCategory: "Solfilm",
    customerType: "Kontor",
    product: "3M Vista 90xc spegelfilm",
    area: "72 kvm",
    region: "skane",
    result: "Spegelfilm monterad på 14 fönster — totalt 72 kvm.",
    gallery: [
      vistahuset6.url,
      vistahuset4.url,
      vistahuset8.url,
      vistahuset2.url,
      vistahuset1.url,
      vistahuset3.url,
      vistahuset5.url,
      vistahuset7.url,
    ],
  },
  {
    slug: "monbijouskolan-prestige-40x",
    image: monbijouskolan1.url,
    city: "Malmö",
    type: "Monbijouskolan",
    client: "Monbijouskolan",
    category: "Skola",
    productCategory: "Solfilm",
    customerType: "Skola",
    product: "3M Prestige 40x",
    area: "580 fönster",
    region: "skane",
    result: "Solfilm monterad på 580 fönster.",
    gallery: [monbijouskolan1.url, monbijouskolan2.url],
  },
  {
    slug: "atea-malmo-insynsskydd-kontrastmarkering",
    image: atea7.url,
    city: "Malmö",
    type: "ATEA",
    client: "ATEA",
    category: "Kontor",
    productCategory: "Dekorfilm",
    customerType: "Kontor",
    product: "Insynsskydd och kontrastmarkering",
    area: "",
    region: "skane",
    gallery: [atea7.url, atea1.url, atea2.url, atea3.url, atea4.url, atea5.url, atea6.url],
  },
  {
    slug: "restaurang-aster-malmo-prestige-40x",
    image: restaurangAster1.url,
    city: "Malmö",
    type: "Restaurang Aster",
    client: "Restaurang Aster",
    category: "Restaurang",
    productCategory: "Solfilm",
    customerType: "Butik",
    product: "3M Prestige 40x",
    area: "",
    region: "skane",
    gallery: [restaurangAster1.url],
  },
  {
    slug: "hoganas-hamnservering-prestige-40x",
    image: hoganasHamnservering1.url,
    city: "Höganäs",
    type: "Höganäs Hamnservering",
    client: "Höganäs Hamnservering",
    category: "Restaurang",
    productCategory: "Solfilm",
    customerType: "Butik",
    product: "3M Prestige 40x",
    area: "120 kvm",
    region: "skane",
    gallery: [
      hoganasHamnservering1.url,
      hoganasHamnservering2.url,
      hoganasHamnservering3.url,
      hoganasHamnservering4.url,
      hoganasHamnservering5.url,
      hoganasHamnservering6.url,
    ],
  },
  // OBS: Endast verifierade projekt med bekräftad fotodokumentation
  // och data direkt från kund publiceras här. Lägg INTE till exempel,
  // gissningar eller "typiska siffror" — varje projekt måste kunna
  // styrkas mot offert/foto innan det får synas på sajten.
];

/**
 * Sorteringsordning för referenser över hela sajten:
 * 1. Nålfästa projekt (pinned) — ligger alltid överst.
 * 2. Övriga i omvänd inmatningsordning — nyast först (nya projekt
 *    append:as sist i PROJECTS och hamnar därmed högst upp).
 */
export function sortProjects(projects: Project[]): Project[] {
  return [...projects].sort((a, b) => {
    if (!!a.pinned === !!b.pinned) return 0;
    return a.pinned ? -1 : 1;
  });
}

/** Projekt med publicerad bild — nålfästa först, därefter nyast överst. */
export const FEATURED_PROJECTS: Project[] = sortProjects(
  PROJECTS.filter((p) => p.image).reverse(),
);

/** Filtrera projekt per stadens namn (nålfästa först, därefter nyast överst). */
export function getProjectsByCity(city: string): Project[] {
  return sortProjects(PROJECTS.filter((p) => p.city === city).reverse());
}

/** Tillgängliga filterval för /referenser-galleriet. */
export const PRODUCT_CATEGORIES: ProductCategory[] = [
  "Solfilm",
  "Säkerhetsfilm",
  "Dekorfilm",
];

export const CUSTOMER_TYPES: CustomerType[] = [
  "Kontor",
  "Butik",
  "Skola",
  "Vård",
  "Offentlig",
  "BRF",
  "Villa",
  "Industri",
];
